import { DashboardShell } from "./DashboardShell";
import { MetricCard } from "./MetricCard";
import { ChartCard } from "./ChartCard";
import { ActivityPanel } from "./ActivityPanel";
import { ProgressListCard } from "./ProgressListCard";
import { StatusListCard } from "./StatusListCard";
import { InsightListCard } from "./InsightListCard";
import { genericPreview } from "@/data/dashboardPreview.data";

interface Props {
    accent: string;
}

export function GenericDashboard({
    accent,
}: Props) {
    const preview = genericPreview;

    return (
        <DashboardShell
            accent={accent}
            title="Business Operations Dashboard"
            subtitle="Enterprise workflow and operational insights"
            sidebar={[
                "Dashboard",
                "Operations",
                "Workflows",
                "Approvals",
                "Analytics",
                "Documents",
                "Users",
                "Reports",
            ]}
        >
            <div className="grid gap-6">

                {/* =====================================================
                   Executive KPIs
                ====================================================== */}

                <div className="grid gap-5 md:grid-cols-4">
                    {
                        preview.metrics.map((metric) => (

                            <MetricCard
                                key={metric.label}
                                accent={accent}
                                label={metric.label}
                                value={metric.value}
                                trend={metric.trend}
                            />

                        ))
                    }

                    {/* <MetricCard
                        accent={accent}
                        label="Active Users"
                        value="2,846"
                        trend="+8%"
                    />

                    <MetricCard
                        accent={accent}
                        label="Open Tasks"
                        value="314"
                        trend="-12%"
                    />

                    <MetricCard
                        accent={accent}
                        label="Completed"
                        value="1,428"
                        trend="+16%"
                    />

                    <MetricCard
                        accent={accent}
                        label="Efficiency"
                        value="96.8%"
                        trend="+4%"
                    /> */}

                </div>

                {/* =====================================================
                   Analytics
                ====================================================== */}

                <div className="grid gap-6 lg:grid-cols-[2fr_1fr]">

                    <ChartCard
                        accent={accent}
                        title={preview.chart.title}
                        values={preview.chart.values}
                    />

                    <ActivityPanel
                        accent={accent}
                        title="Recent Activity"
                        items={preview.activities ?? []}
                    />

                </div>
                {/* =====================================================
                   Operations
                ====================================================== */}

                <div className="grid gap-6 lg:grid-cols-3">

                    <ProgressListCard
                        title="Department Performance"
                        accent={accent}
                        items={[
                            {
                                label: "Operations",
                                value: 92,
                            },
                            {
                                label: "Finance",
                                value: 84,
                            },
                            {
                                label: "HR",
                                value: 79,
                            },
                            {
                                label: "Administration",
                                value: 88,
                            },
                        ]}
                    />

                    <StatusListCard
                        title="Approval Queue"
                        accent={accent}
                        items={[
                            {
                                title: "Purchase Request",
                                subtitle: "Finance Approval",
                                status: "Pending",
                                color: "yellow",
                            },
                            {
                                title: "Vendor Registration",
                                subtitle: "Compliance Review",
                                status: "Approved",
                                color: "green",
                            },
                            {
                                title: "Policy Update",
                                subtitle: "Management Review",
                                status: "Review",
                                color: "blue",
                            },
                            {
                                title: "Leave Request",
                                subtitle: "HR Approval",
                                status: "Waiting",
                                color: "orange",
                            },
                        ]}
                    />

                    <InsightListCard
                        title="AI Recommendations"
                        items={[
                            "Automate repetitive approval workflows.",
                            "Review departments with slower response times.",
                            "Archive inactive business records.",
                            "Predict workload increase for next month.",
                        ]}
                    />

                </div>
                {/* =====================================================
                   Executive Summary
                ====================================================== */}

                <div className="grid gap-5 md:grid-cols-4">

                    <MetricCard
                        accent={accent}
                        label="Automation Rate"
                        value="81%"
                        trend="+11%"
                    />

                    <MetricCard
                        accent={accent}
                        label="SLA Compliance"
                        value="98.2%"
                        trend="+3%"
                    />

                    <MetricCard
                        accent={accent}
                        label="Processing Time"
                        value="4.2 hrs"
                        trend="-18%"
                    />

                    <MetricCard
                        accent={accent}
                        label="User Satisfaction"
                        value="95%"
                        trend="+5%"
                    />

                </div>

            </div>

        </DashboardShell>
    );
}